// components/Dropdown.tsx
import { Dropdown as AntDropdown, MenuProps } from "antd";
import React, { JSX } from "react";
import { HiOutlineEllipsisVertical } from "react-icons/hi2";

interface DropdownProps {
  items: MenuProps["items"];
  onClick?: MenuProps["onClick"];
  className?: string;
  icon?: JSX.Element | null;
}

const Dropdown: React.FC<DropdownProps> = ({
  items,
  onClick,
  className,
  icon,
}) => {
  return (
    <AntDropdown
      trigger={["click"]}
      menu={{
        items,
        onClick,
        className: "custom-dropdown-menu",
      }}
      placement="bottomRight"
    >
      {icon ? (
        icon
      ) : (
        <HiOutlineEllipsisVertical
          className={`text-xl cursor-pointer rounded-sm hover:backdrop-brightness-90 transition-all ease-in duration-200 ${className}`}
        />
      )}
    </AntDropdown>
  );
};

export default Dropdown;
